import { render } from "./OfferSpecificationItem.vue?vue&type=template&id=9f83eaea"
import script from "./OfferSpecificationItem.vue?vue&type=script&lang=js"
export * from "./OfferSpecificationItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__